import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltInlineCommentsSectionSortingDropdownContentWireframe from './VeltInlineCommentsSectionSortingDropdownContentWireframe/VeltInlineCommentsSectionSortingDropdownContentWireframe';
import VeltInlineCommentsSectionSortingDropdownTriggerWireframe from './VeltInlineCommentsSectionSortingDropdownTriggerWireframe/VeltInlineCommentsSectionSortingDropdownTriggerWireframe';
var VeltInlineCommentsSectionSortingDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionSortingDropdownWireframe.Content = VeltInlineCommentsSectionSortingDropdownContentWireframe;
VeltInlineCommentsSectionSortingDropdownWireframe.Trigger = VeltInlineCommentsSectionSortingDropdownTriggerWireframe;
export default VeltInlineCommentsSectionSortingDropdownWireframe;
